import React, { useCallback } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { useOverlays } from "contexts/OverlayContext";
import { CounterpartyDirectoryViewRow } from "../counterpartyDirectoryViewTypes";
import { CounterpartyCountCell } from "./CounterpartyCountCell";

export const CounterpartyInvoicesCell: React.FC<
    CellContext<ViewTableFeatures, CounterpartyDirectoryViewRow, number>
> = React.memo(({ row, table }) => {
    const { openOverlay } = useOverlays();

    const counterpartyId = row.original.counterparty?.id;
    const count = row.original.invoiceCount ?? 0;
    const isDisabled = !counterpartyId || count === 0;

    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();
            if (!counterpartyId) {
                return;
            }
            openOverlay("invoicesDrilldown", {
                filters: { counterpartiesIds: [counterpartyId] },
            });
        },
        [counterpartyId, openOverlay],
    );

    return (
        <CounterpartyCountCell
            count={count}
            isDisabled={isDisabled}
            table={table}
            onClick={handleClick}
        />
    );
});

CounterpartyInvoicesCell.displayName = "CounterpartyInvoicesCell";
